<template lang="pug">
  v-dialog(
    :value="value"
    :persistent="true"
    max-width="50rem")
    v-card
      v-card-text
        v-form(v-model="valid")
          v-container(grid-list-md)
            v-layout
              v-flex
                v-text-field(
                  v-model="editedCost.name"
                  :rules="[v => !!v || 'Name is required']"
                  label="Name")
            v-layout
              v-flex
                v-text-field(
                  v-model="editedCost.class"
                  :rules="[\
                    (v) => !!v || 'Class is required',\
                    (v) => v === '1' || v === '2' ||\
                      v === 1 || v === 2 || 'Should be 1 or 2'\
                  ]"
                  label="Class")
            v-layout
              v-flex
                v-textarea(
                  v-model="editedCost.description"
                  auto-grow
                  label="Description"
                  rows="1")
            v-layout
              v-flex
                v-text-field(
                  v-model="editedCost.purchaseOrder"
                  :rules="poRules"
                  label="Purchase order ID")
            v-layout
              v-flex
                v-text-field(
                  v-model="editedCost.unit"
                  :rules="[v => !!v || 'Unit is required']"
                  label="Unit")
            v-layout
              v-flex
                v-text-field(
                  v-model="editedCost.value"
                  :rules="valueRules"
                  label="Value")

      v-card-actions
        v-spacer
        v-btn(
          :disabled="posting"
          flat
          @click="$emit('input', false)") Cancel
        v-btn(
          :disabled="posting || !valid"
          flat
          @click="save")
          v-progress-circular(
            v-if="posting"
            indeterminate)
          span(v-else) Save

</template>

<script>
export default {
  name: "edit-cost-dialog",
  props: {
    cost: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      editedCost: {},
      poRules: [
        (v) => !!v && v.substring(0, 3) === "PO-" || "Must start with 'PO-'",
        (v) => !!v && v.length > 3 || "Must specify an ID"
      ],
      posting: false,
      valueRules: [
        (v) => !!v || "Real cost is required",
        (v) => !isNaN(parseFloat(v)) || "Must be a number",
        (v) => typeof v === "string" && !isNaN(parseFloat(v)) &&
        parseFloat(v).toFixed(2).length >= v.length || "Precision too high"
      ],
      valid: false
    };
  },
  watch: {
    value (newVal) {
      if (newVal === true) {
        Object.assign(this.editedCost, this.cost);
      }
    }
  },
  methods: {
    save () {
      this.posting = true;
      this.$http.
        put(`/api/job_costs/${this.cost.id}`, {
          class: this.editedCost.class,
          description: this.editedCost.description,
          name: this.editedCost.name,
          purchaseOrder: this.editedCost.purchaseOrder,
          unit: this.editedCost.unit,
          value: this.editedCost.value
        }).
        then(() => {
          this.$emit("refresh");
          this.$emit("input", false);
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Job/Costs/EditCostDialog.vue